var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { throttle } from '@feb-team/data-logic';
import { addEventListenerWrap } from '../../Utils/react';
import { DivTag } from '../../Utils/AtomicTag';
import qs from '../BackTop/qs';
import { qsa, scroll } from '../../Utils/browser';
import { scrollTo } from '../../Utils/browser';
import { getOffset } from '../../Utils/browser';
var Elevator = /** @class */ (function (_super) {
    __extends(Elevator, _super);
    function Elevator(props) {
        var _this = _super.call(this, props) || this;
        _this.keys = {};
        _this.handleResize = function () {
            _this.setState({
                middle: window.innerHeight / 2,
            });
        };
        _this.isActive = function (element) {
            var middle = _this.state.middle;
            if (_this.props.scrollContainer === window) {
                try {
                    var floorRect = element.getBoundingClientRect();
                    return ((floorRect.top <= middle && floorRect.bottom > middle) ||
                        (floorRect.top > -1 && floorRect.bottom < middle));
                }
                catch (error) {
                    console.warn('不支持getBoundingClientRect方法');
                }
            }
            else {
                var eleOffsetTop = element.offsetTop;
                var boxHeight = _this.scrollContainer.offsetHeight / 2;
                var sTop = scroll(_this.scrollContainer).top;
                return eleOffsetTop - sTop < boxHeight && eleOffsetTop - sTop >= 0;
            }
        };
        _this.handleScroll = function () {
            var _a = _this.props, wrapCls = _a.wrapCls, triggerOffset = _a.triggerOffset, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, onToggle = _a.onToggle;
            var _b = _this.state, show = _b.show, active = _b.active;
            var domList = wrapCls
                ? getElevatorArray('[data-elevator]', "." + wrapCls)
                : getElevatorArray('[data-elevator]');
            var pageYOffset = scroll(_this.scrollContainer).top;
            var activeFloor = (domList || []).length > 0 ? (domList || []).filter(_this.isActive) : [];
            var activeParam;
            if (activeFloor.length > 0) {
                var itemsData = (domList || []).map(function (dom) { return dom.getAttribute('data-elevator'); });
                var activeElevator = activeFloor[0].getAttribute('data-elevator');
                activeParam = itemsData.indexOf(activeElevator);
            }
            else {
                activeParam = active;
            }
            // const scrollTop = document.scrollingElement ? document.scrollingElement.scrollTop : -1
            // const pageYOffset = scrollTop !== -1 ? scrollTop : window.pageYOffset
            _this.showParam = pageYOffset >= triggerOffset;
            var param = {
                show: show,
                active: active,
            };
            if (_this.showParam !== show) {
                param = Object.assign(param, {
                    show: _this.showParam,
                });
            }
            if (active !== activeParam) {
                param = Object.assign(param, {
                    active: activeParam,
                });
                if (onBeforeChange(_this)) {
                    onChange(_this);
                }
            }
            if (show !== param.show || active !== param.active) {
                _this.setState({
                    show: param.show,
                    active: param.active,
                });
            }
            if (_this.showParam !== show) {
                onToggle(_this.showParam);
            }
        };
        _this.goTo = function (active) {
            var _a = _this.props, offsetTop = _a.offsetTop, wrapCls = _a.wrapCls, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, duration = _a.duration, scrollContainer = _a.scrollContainer;
            _this.setState({
                activeIndex: active,
            }, function () {
                if (onBeforeChange(_this)) {
                    onChange(_this);
                }
            });
            var domList = wrapCls
                ? getElevatorArray('[data-elevator]', "." + wrapCls)
                : getElevatorArray('[data-elevator]');
            var activeFloorTop = domList
                ? scrollContainer === window
                    ? getOffset(domList[active]).offsetTop
                    : domList[active].offsetTop
                : 0;
            var top;
            if (offsetTop !== 0) {
                top = activeFloorTop + offsetTop;
            }
            else {
                top = activeFloorTop;
            }
            scrollTo(0, top, {
                duration: duration,
            }, function () { }, _this.scrollContainer);
        };
        _this.renderContentItem = function (item, index) {
            var renderItem = _this.props.renderItem;
            var key = "item-" + index;
            if (!renderItem)
                return item;
            _this.keys[index] = key;
            return renderItem(item, index);
        };
        _this.renderItems = function () {
            var _a = _this.props, items = _a.items, activeCls = _a.activeCls, wrapCls = _a.wrapCls;
            var active = _this.state.active;
            var itemsData = items;
            if (itemsData.length === 0) {
                var domList = wrapCls
                    ? getElevatorArray('[data-elevator]', "." + wrapCls)
                    : getElevatorArray('[data-elevator]');
                itemsData = (domList || []).map(function (dom) { return dom.getAttribute('data-elevator'); });
            }
            if (itemsData.length > 0) {
                var uniqueData = Array.from(new Set(itemsData));
                if (uniqueData.length !== itemsData.length) {
                    console.warn('定义了重复楼层');
                }
                var atomicItem_1 = 'cursor-pointer';
                var activeIndex_1 = active;
                var itemsList = __spread(itemsData).map(function (item, index) {
                    return _this.renderContentItem(item, index);
                });
                var childrenList = React.Children.map(itemsList, function (child, index) {
                    if (!child) {
                        return null;
                    }
                    var childCls = (activeIndex_1 === index
                        ? activeCls
                            ? activeCls
                            : 'text-brand-600'
                        : '');
                    var setChildCls = childCls.split(/\s/g);
                    return (React.createElement(DivTag, { atomics: __spread([atomicItem_1], setChildCls, ['p-2']), key: _this.keys[index], onClick: function () { return _this.goTo(index); } }, child));
                });
                return React.createElement(React.Fragment, null, childrenList);
            }
            return null;
        };
        _this.state = {
            active: props.defaultActive,
            show: true,
            middle: 0,
            activeIndex: props.defaultActive,
        };
        _this.scrollContainer = window;
        _this.showParam = false;
        _this.scrollEvent = null;
        _this.resizeEvent = null;
        return _this;
    }
    Elevator.prototype.componentDidMount = function () {
        var scrollContainer = this.props.scrollContainer;
        if (scrollContainer === window) {
            this.scrollContainer = scrollContainer;
        }
        else {
            var ele = qs(scrollContainer);
            this.scrollContainer = ele ? ele : window;
        }
        this.setState({ middle: window.innerHeight / 2 });
        this.handleResize = throttle(this.handleResize, 500);
        this.handleScroll = throttle(this.handleScroll, 100);
        // @ts-ignore
        this.scrollEvent = addEventListenerWrap(this.scrollContainer, 'scroll', this.handleScroll);
        // @ts-ignore
        this.resizeEvent = addEventListenerWrap(this.scrollContainer, 'scroll', this.handleResize);
    };
    Elevator.prototype.componentWillUnmount = function () {
        if (this.scrollEvent) {
            this.scrollEvent.remove();
        }
        if (this.resizeEvent) {
            this.resizeEvent.remove();
        }
    };
    Elevator.prototype.render = function () {
        var show = this.state.show;
        var _a = this.props, children = _a.children, className = _a.className, wrapCls = _a.wrapCls, defaultActive = _a.defaultActive, onToggle = _a.onToggle, onBeforeChange = _a.onBeforeChange, onChange = _a.onChange, offsetTop = _a.offsetTop, triggerOffset = _a.triggerOffset, activeCls = _a.activeCls, items = _a.items, renderItem = _a.renderItem, scrollContainer = _a.scrollContainer, rest = __rest(_a, ["children", "className", "wrapCls", "defaultActive", "onToggle", "onBeforeChange", "onChange", "offsetTop", "triggerOffset", "activeCls", "items", "renderItem", "scrollContainer"]);
        var childHtml = this.renderItems();
        var setWrapCls = show ? 'opacity-100' : 'opacity-0';
        return (React.createElement(DivTag, __assign({ name: Elevator.NAME, atomics: setWrapCls, className: className + " " + wrapCls }, rest), childHtml));
    };
    Elevator.defaultProps = defaultProps;
    Elevator.NAME = 'elevator';
    Elevator.displayName = 'Elevator';
    return Elevator;
}(PureComponent));
export { Elevator };
var getElevatorArray = function (selector, wrapClassName) {
    var domList;
    if (wrapClassName) {
        domList = qsa(wrapClassName + " " + selector);
        return domList && Array.from(domList);
    }
    domList = qsa(selector);
    return domList && Array.from(domList);
};
